import React from 'react';
import { FormContext } from 'react-hook-form';
import { Trans } from '@lingui/macro';
import { isEmpty } from 'lodash';
import styled from 'styled-components/native';

import AuthenticationContainer from '@src/components/AuthenticationContainer';
import AuthenticationSendButton from '@src/components/AuthenticationSendButton';
import Image from '@src/components/Image';
import LabelInput from '@src/components/LabelInput';
import { Body1 } from '@src/components/Typography';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { padding } from '@src/configuration/constants';

import { Props } from './types';
import useForm from './useForm';

const Text = styled(Body1)`
  text-align: center;
  margin: ${padding}px 0;
`;
const Labels2Banner: React.FC = styled(Image).attrs({
  source: require('./labels2.jpg'),
  resizeMode: 'cover',
})`
  width: 100%;
  height: 100px;
  margin-bottom: ${padding}px;
`;

const Screen: React.FC<Props> = ({ navigation }) => {
  const { form, handleSubmit, loading, labels } = useForm();

  React.useLayoutEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <AuthenticationSendButton
          loading={loading}
          disabled={loading || !isEmpty(form.errors)}
          onPress={handleSubmit}
        >
          <Trans>Next</Trans>
        </AuthenticationSendButton>
      ),
    });
  }, [form.errors, handleSubmit, loading, navigation]);

  return (
    <>
      <VisibleStatusBar />
      <AuthenticationContainer>
        <FormContext {...form}>
          <LabelInput
            ListHeaderComponent={
              <>
                <Text>
                  <Trans>
                    You can read and check many travel logs based on other users
                    experiences
                  </Trans>
                </Text>
                <Labels2Banner />
              </>
            }
            name="labels"
            labels={labels.data}
            multiple
            split
          />
        </FormContext>
      </AuthenticationContainer>
    </>
  );
};

Screen.displayName = 'SetupLabels';

export default React.memo(Screen);
